export default "__VITE_ASSET__DhVXx1YQ__"